import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/joy';
import { useNavigate } from 'react-router';

interface ErrorPageProps {
    message?: string;
    status?: number;
}

const ErrorPage = ({ message, status }: ErrorPageProps) => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="60vh"
        >
            <Stack spacing={3} alignItems="center" textAlign="center">
                <Typography level="h1" color="danger">
                    Oops!
                </Typography>
                <Typography level="h4">
                    Something went wrong.
                </Typography>
                {status && (
                    <Typography level="body-md">
                        Status Code: {status}
                    </Typography>
                )}
                <Typography level="body-md">
                    {message || 'An unexpected error occurred while communicating with the server.'}
                </Typography>
                <Button variant="soft" color="primary" onClick={() => navigate('/')}>
                    Go Back Home
                </Button>
            </Stack>
        </Box>
    );
};

export default ErrorPage;
